import { PaletteOptions } from '@mui/material';

declare module '@mui/material/styles' {
  interface PaletteColor {
    900?: string;
  }
}

export const palette: PaletteOptions = {
  mode: 'light',
  background: {
    default: '#EDEBF4',
  },
  text: {
    primary: '#18243E',
  },
  primary: {
    main: '#EB6E71',
    dark: '#2D0202',
    '900': '',
    '800': '',
    '700': '',
    '600': '',
    '500': '',
    '400': '',
    '300': '',
    '200': '',
    '100': '',
    '50': '',
  },
  secondary: {
    main: '#FF9B00',
  },
  success: {
    main: '#FE7A4D',
    light: '#87BB89',
    dark: '#28593D',
    '100': '#D6E8D7',
  },
  error: {
    main: '#BE181B',
    light: '#EE6971',
    dark: '#7E1529',
    '100': '#F9CCCF',
  },
  warning: {
    main: '#F57C00',
    light: '#F8B065',
    dark: '#87501F',
    '100': '#FCE4CB',
  },
  info: {
    main: '#D9D9D9',
  },
  common: {
    black: '#18243E',
    white: '#FFFFFF',
  },
  grey: {
    '900': '#2E3950',
    '800': '#464F64',
    '700': '#5C6577',
    '600': '#747B8B',
    '500': '#8B919E',
    '400': '#A2A7B1',
    '300': '#B9BCC4',
    '200': '#D0D3D8',
    '100': '#1D1B20',
    '50': '#F5F5F5',
    A100: '#F8F9FB',
    A200: '#CCCCCC',
    A400: '#D9D9D9',
    A700: '#808080',
  },
};
